module.exports = __webpack_public_path__ + "static/media/NewsIntro.7c116a38.wav";